/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit IncludedInInsuranceClaim/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function IncludedInInsuranceClaim({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Charges/AddAction/Add/Content/IncludedInInsuranceClaim",
  onChange
  
}) {
let chargeIsIncludedInInsuranceClaimValueData = fromData.useDataValue({ viewPath,
context: 'charge',
path: 'is_included_in_insurance_claim',
})
let chargeIsIncludedInInsuranceClaimChangeData = fromData.useDataChange({ viewPath,
context: 'charge',
path: 'is_included_in_insurance_claim',
})
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 data="charge.is_included_in_insurance_claim"
 value={chargeIsIncludedInInsuranceClaimValueData}
 onChange={chargeIsIncludedInInsuranceClaimChangeData}
 marginTop={0}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text="Include in insurance claim"
/>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}